import classes from './FlexDiv.module.css'
import React from 'react'
// import React,{useState,useEffect} from 'react'
export const Row=(props)=>
<div style={props.style?props.style:{}} id={props.id?props.id:''} className={`${classes['display-flex']} ${classes['flex-direction-row']} ${props.className?props.className:''}`}>
{props.children}
</div>
export const Column=(props)=>
<div style={props.style?props.style:{}} id={props.id?props.id:''} className={`${classes['display-flex']} ${classes['flex-direction-column']} ${props.className?props.className:''}`}>
{props.children}
</div>
export const Container=(props)=>
<div id={props.id?props.id:''} className={`${classes['Container']} ${props.className?props.className:''}`}>
{props.children}
</div>
export const FlexContainer=(props)=>
<div id={props.id?props.id:''} className={`${props.className?props.className:''}`}>
{props.children}
</div>
export const TwoColumnLayout=({leftColumn='',rightColumn='',leftColumnClassName='',rightColumnClassName='',rowClassName=''})=>{
    return <Row className={`${rowClassName} ${classes['padding-1per']}`}>
        <Column className={`${classes['left-column']} ${leftColumnClassName}`}>
        {leftColumn}
        </Column>
        <Column className={`${classes['right-column']} ${rightColumnClassName}`}>
        {rightColumn}
        </Column>
    </Row>
}